import { useNavigate, useLocation } from 'react-router-dom';
import { useComparisonSelectionStore } from '../../store/comparisonSelectionStore';
import { trackEvent } from '../../services/analytics';

export function ComparisonFab() {
  const { selectedProfileIds, clearSelection } = useComparisonSelectionStore();
  const navigate = useNavigate();
  const location = useLocation();

  if (selectedProfileIds.length === 0 || location.pathname === '/compare') return null;

  const canCompare = selectedProfileIds.length >= 2;

  return (
    <div className="fixed bottom-6 right-6 bg-white shadow-xl rounded-lg p-4 border-2 border-blue-500 z-50">
      <div className="text-sm text-gray-600 mb-3 text-center font-medium">
        {selectedProfileIds.length} / 3 offerings selected
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => {
            trackEvent('compare_started', {
              source: 'comparison_fab',
              selected_count: selectedProfileIds.length,
            });
            navigate('/compare');
          }}
          disabled={!canCompare}
          className={`px-4 py-2 rounded font-medium transition-colors ${
            canCompare
              ? 'bg-blue-600 text-white hover:bg-blue-700'
              : 'bg-gray-200 text-gray-600 cursor-not-allowed'
          }`}
        >
          Compare
        </button>

        <button
          onClick={clearSelection}
          className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded font-medium transition-colors"
        >
          Clear
        </button>
      </div>
    </div>
  );
}
